module.exports = __webpack_public_path__ + "box-icon.d6401001c1942b6eeed332009f414d91.svg";